import React from 'react'
import Corousel from '../Corousel/Corousel'
import ServicesHome from '../ServicesHome/ServicesHome'
import NewsSection from '../NewsSection/NewsSection'
import DepartmentDetails from '../DepartmentDetails/DepartmentDetails'
import BottomSlider from '../BottomSlider/BottomSlider'
import Minister from '../Minister/Minister'

const MainHome = () => {
  return (
    <>
    <Corousel />
    <div id="main-content">
    <Minister />
    <ServicesHome />
    <NewsSection />
    <DepartmentDetails />
    <BottomSlider />
    </div>
    </>
  )
}

export default MainHome